import React, { createContext, useContext } from 'react';

import {
  FixedIncomeDistributionFee,
  FixedIncomeOfferEntityNormalized,
} from '../../../../../../../store/product/types';

interface FixedIncomeAssetContextReceivedData {}

interface FixedIncomeAssetContextData extends FixedIncomeAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: FixedIncomeOfferEntityNormalized | undefined;
  setOfferSelected: React.Dispatch<
    React.SetStateAction<FixedIncomeOfferEntityNormalized | undefined>
  >;
  offerFeeSelected: FixedIncomeDistributionFee | undefined;
  setOfferFeeSelected: React.Dispatch<React.SetStateAction<FixedIncomeDistributionFee | undefined>>;
}

interface Props extends FixedIncomeAssetContextReceivedData {
  children: React.ReactNode;
}

const FixedIncomeAssetContext = createContext<FixedIncomeAssetContextData>(
  {} as FixedIncomeAssetContextData
);

const FixedIncomeAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] = React.useState<FixedIncomeOfferEntityNormalized>();
  const [offerFeeSelected, setOfferFeeSelected] = React.useState<FixedIncomeDistributionFee>();

  return (
    <FixedIncomeAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
        offerFeeSelected,
        setOfferFeeSelected,
      }}>
      {children}
    </FixedIncomeAssetContext.Provider>
  );
};

const useFixedIncomeAssetContext = (): FixedIncomeAssetContextData => {
  const context = useContext(FixedIncomeAssetContext);

  if (!context) {
    throw new Error('useFixedIncomeAssetContext must be used within an FixedIncomeAssetContext');
  }
  return context;
};

export { FixedIncomeAssetProvider, useFixedIncomeAssetContext, FixedIncomeAssetContextData };
